/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Card, Form, Input, Button, Flex, message, Typography } from "antd";
import { Row, Col, Space, InputNumber, Divider, Badge, Select } from "antd";

import { SaveFilled, SearchOutlined } from "@ant-design/icons";

import { ButtonBack } from "../../../components/button";
import ModalSupplier from "../../../components/modal/supplier/ModalSupplier";
import ModalUnit from "../../../components/modal/ERP/unit/ModalUnit.jsx";

import { pkmaster } from "./model";
import RawMaterialService from "../../../service/ERP/RawMaterial.service";
import OptionService from "../../../service/ERP/Options.service";
import { useLocation, useNavigate } from "react-router";
import { delay } from "../../../utils/util";

const pkservice = RawMaterialService();
const opService = OptionService();
const { Text } = Typography;

const from = "/ERP/raw-material";

const RawMaterialManage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { config } = location.state || { config: null };
  const [form] = Form.useForm();

  const [optionPrefix, setOptionPrefix] = useState([]);

  const [formDetail, setFormDetail] = useState(pkmaster);

  const [openModalSupplier, setOpenModalSupplier] = useState(false);
  const [openModalUnit, setOpenModalUnit] = useState(false);
  // const [packageTypeOption, setPackageTypeOption] = useState([]);
  const [prefixCode, setPrefixCode] = useState(null);
  const [rmCode, setRmCode] = useState("");

  /* โหมดดูอย่างเดียว — ปิดการแก้ไขทั้งฟอร์ม ซ่อนปุ่มบันทึก */
  const isView = config?.action === "view";

  const init = async () => {
    if (config?.action !== "create") {
      pkservice
        .get(config?.code)
        .then(async (res) => {
          const { data: detail } = res.data;
          const initialValues = { ...pkmaster, ...detail };

          form.setFieldValue("rm_code1", detail.rm_code);
          setFormDetail(initialValues);
          form.setFieldsValue(initialValues);
        })
        .catch((err) => {
          // console.warn(err);
          const { data } = err.response;
          message.error(data?.message || "error request");
        });
    } else {
      form.setFieldValue("multiply", 1);
      form.setFieldValue("yield", 0);
      setFormDetail(pkmaster);
      form.setFieldsValue(pkmaster);
    }
  };

  useEffect(() => {
    init();
    GetPrefix();
    return () => {};
  }, []);

  useEffect(() => {
    fnsetRMcode(); // อัปเดตค่า fgCode เมื่อฟอร์มเปลี่ยนแปลง
    // alert(fgCode);
  }, [form.getFieldValue("rm_code")]);
  // alert(form.getFieldValue("prefixLabel"));
  const fnsetRMcode = () => {
    setRmCode(
      (form.getFieldValue("prefixLabel") !== undefined
        ? form.getFieldValue("prefixLabel")
        : "") +
        (form.getFieldValue("prefixLabel") !== undefined &&
        form.getFieldValue("rm_code") !== undefined
          ? "-"
          : "") +
        (form.getFieldValue("rm_code") !== undefined
          ? form.getFieldValue("rm_code")
          : "")
    ); // อัปเดตค่า fgCode เมื่อฟอร์มเปลี่ยนแปลง
  };

  const GetPrefix = () => {
    opService.optionsRuncode({ p: "rm" }).then((res) => {
      let { data } = res.data;
      // let code = data.run_number
      setOptionPrefix(data);
    });
  };

  const handleChoosedSupplier = (v) => {
    const f = form.getFieldsValue();
    const val = { ...formDetail, ...f, supcode: v.supcode, supname: v.supname };
    setFormDetail(val);

    form.setFieldsValue(val);
  };

  const handleChoosedUnit = (value) => {
    // console.log(value);
    const f = form.getFieldValue();
    const initialValues = {
      ...formDetail,
      ...f,
      unit: value.unitname,
    };
    form.setFieldsValue(initialValues);
    setFormDetail(initialValues);
  };

  const handleConfirm = () => {
    form.validateFields().then((v) => {
      const parm = {
        ...formDetail,
        ...form.getFieldsValue(),
        prefixLabel: form.getFieldValue("prefixLabel"),
      };
      const actions =
        config?.action !== "create"
          ? pkservice.update(parm)
          : pkservice.create(parm);
      // console.log(parm)

      actions
        .then(async (r) => {
          message.success("Request success.");

          navigate(from, { replace: true });
          await delay(300);
          console.clear();
        })
        .catch((err) => {
          console.warn(err);
          const data = err?.response?.data;
          message.error(data?.message || "error request");
        });
    });
  };

  const dividerProp = {
    orientation: "left",
    style: { marginBlock: 10 },
    className: "!border-black",
  };

  const prefixSelector = (
    <Form.Item name="prefixid" noStyle>
      <Select
        style={{
          width: 350,
          textAlign: "left",
          paddingLeft: "10px",
        }}
        onChange={(v, l) => {
          form.setFieldValue("prefixLabel", l.text);
          // alert(l.text);
          // หรือเก็บใน state
          setPrefixCode(l.id);
          opService
            .optionsGetLastcode({ p: "rawmaterial", id: v })
            .then((res) => {
              let { data } = res;
              setPrefixCode(data.data);
              const val = {
                ...formDetail,
                prefix: l.text,
              };
              setFormDetail(val);
            });
          fnsetRMcode();
        }}
        options={optionPrefix.map((item) => ({
          value: item.id,
          label: item.value + " - " + item.definition,
          text: item.value,
        }))}
      ></Select>
    </Form.Item>
  );

  let redcode = (
    <>
      {rmCode && rmCode !== "NaN" && (
        <span style={{ paddingLeft: "20px" }}>
          {"ตัวอย่างรหัสใหม่ " + rmCode}
        </span>
      )}
      <span style={{ color: "red", paddingLeft: "10px" }}>
        {prefixCode !== null ? " รหัสล่าสุด " + prefixCode : ""}
      </span>
    </>
  );

  const Detail = (
    <>
      <Row gutter={[8, 8]} className="px-2 sm:px-4 md:px-4 lg:px-4">
        <Divider {...dividerProp}>ข้อมูลหลัก</Divider>
        <Col
          xs={24}
          sm={24}
          md={12}
          lg={12}
          xl={12}
          xxl={12}
          style={
            config.action !== "edit"
              ? { display: "inline" }
              : { display: "none" }
          }
        >
          <Form.Item
            label={
              <span>
                <span>Raw Material Code</span>
                {redcode}
              </span>
            }
            name="rm_code"
            rules={[{ required: true, message: "Please enter data!" }]}
          >
            <Input
              addonBefore={
                <Text
                  style={{
                    width: 150,
                  }}
                >
                  {prefixSelector}
                </Text>
              }
              onChange={() => fnsetRMcode()}
              placeholder="Enter Raw Material Code."
            />
          </Form.Item>
        </Col>
        <Col
          xs={24}
          sm={24}
          md={12}
          lg={12}
          xl={12}
          xxl={12}
          style={
            config.action === "edit" || config.action === "view"
              ? { display: "inline" }
              : { display: "none" }
          }
        >
          <Form.Item label="Raw Material Code" name="rm_code1">
            <Input readOnly />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
          <Form.Item
            label="Raw Material Name"
            name="rm_name"
            rules={[{ required: true, message: "Please enter data!" }]}
          >
            <Input placeholder="Enter Raw Material Name." />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
          <Form.Item label="Raw Material Name (English)" name="rm_nameEN">
            <Input placeholder="Enter RawMaterial Name." />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
          <Form.Item label="Express Name" name="express_name">
            <Input placeholder="Enter Express Name." />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
          <Form.Item label="ชื่อที่ใช้สั่งซื้อ" name="purchase_name">
            <Input placeholder="Enter Purchase Name." />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
          <Form.Item label="หน่วยสินค้า :" name="unit">
            <Space.Compact style={{ width: "100%" }}>
              <Input
                readOnly
                placeholder="Select Unit"
                value={!!formDetail.unit ? `${formDetail.unit} ` : ""}
              />
              <Button
                type="primary"
                icon={<SearchOutlined />}
                onClick={() => setOpenModalUnit(true)}
                style={{ minWidth: 40 }}
              ></Button>
            </Space.Compact>
          </Form.Item>
        </Col>        
        <Col
           xs={24} sm={24} md={12} lg={12} xl={8}
          style={
            config.action === "edit" || config.action === "view"
              ? { display: "inline" }
              : { display: "none" }
          }
        >
          <Form.Item label="สถานะการใช้งาน" name="active_status">
            <Select
              size="large"
              options={[
                {
                  value: "เปิดการใช้งาน",
                  label: <Badge status="success" text="เปิดการใช้งาน" />,
                },
                {
                  value: "ปิดการใช้งาน",
                  label: <Badge status="error" text="ปิดการใช้งาน" />,
                },
              ]}
            />
          </Form.Item>
        </Col>
      </Row>
      <Divider {...dividerProp}>ข้อมูลใช้คำนวน</Divider>
      <Row gutter={[8, 8]} className="px-2 sm:px-4 md:px-4 lg:px-4">
        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
          <Form.Item name="multiply" label="ตัวคูณน้ำหนัก">
            <InputNumber
              style={{ width: "100%" }}
              size="large"
              min="0"
              max="100"
              step="0.01"
              placeholder="ใส่ตัวคูณน้ำหนัก"
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
          <Form.Item name="yield" label="Yield">
            <InputNumber
              style={{ width: "100%" }}
              addonAfter="%"
              size="large"
              min="0"
              max="100"
              step="0.01"
              placeholder="ใส่ค่า Yield"
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
          <Form.Item name="shelf_life" label="Shelf life">
            <InputNumber
              style={{ width: "100%" }}
              addonAfter="วัน"
              size="large"
              min="0"
              step={1}
              precision={0}
              placeholder="ใส่วัน Shelf life"
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
          <Form.Item name="min_stock" label="สต๊อกขั้นต่ำ">
            <InputNumber
              style={{ width: "100%" }}
              size="large"
              min="0"
              placeholder="ใส่จำนวนสต๊อกขั้นต่ำ"
            />
          </Form.Item>
        </Col>
      </Row>
      <Divider {...dividerProp}>อื่นๆ</Divider>
      <Row gutter={[8, 8]} className="px-2 sm:px-4 md:px-4 lg:px-4">
        <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
          <Form.Item label="Remark" name="remark">
            <Input.TextArea placeholder="Enter Remark." rows={5} />
          </Form.Item>
        </Col>
      </Row>
    </>
  );

  const SectionTop = (
    <Row
      gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
      className="m-0"
    >
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start">
          <ButtonBack target={from} />
        </Flex>
      </Col>
      {!isView && (
        <Col span={12} style={{ paddingInline: 0 }}>
          <Flex gap={4} justify="end">
            <Button
              icon={<SaveFilled style={{ fontSize: "1rem" }} />}
              type="primary"
              style={{ width: "9.5rem" }}
              onClick={() => {
                handleConfirm();
              }}
            >
              Save
            </Button>
          </Flex>
        </Col>
      )}
      {/* <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={4} justify="end">
          {!!code && (
            <ButtonUpload code={code} refer="RawMaterial" showExpire={true} />
          )}
        </Flex>
      </Col> */}
    </Row>
  );

  const SectionBottom = (
    <Row
      gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
      className="m-0"
    >
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start">
          <ButtonBack target={from} />
        </Flex>
      </Col>
      {!isView && (
        <Col span={12} style={{ paddingInline: 0 }}>
          <Flex gap={4} justify="end">
            <Button
              icon={<SaveFilled style={{ fontSize: "1rem" }} />}
              type="primary"
              style={{ width: "9.5rem" }}
              onClick={() => {
                handleConfirm();
              }}
            >
              Save
            </Button>
          </Flex>
        </Col>
      )}
    </Row>
  );

  return (
    <div className="packaging-manage xs:px-0 sm:px-0 md:px-8 lg:px-8">
      <Space direction="vertical" className="flex gap-2">
        {SectionTop}
        <Form form={form} layout="vertical" autoComplete="off" disabled={isView}>
          <Card title={config?.title}>{Detail}</Card>
        </Form>
        {SectionBottom}
      </Space>

      {openModalSupplier && (
        <ModalSupplier
          show={openModalSupplier}
          close={() => {
            setOpenModalSupplier(false);
          }}
          values={(v) => {
            handleChoosedSupplier(v);
          }}
        />
      )}

      {openModalUnit && (
        <ModalUnit
          show={openModalUnit}
          close={() => {
            setOpenModalUnit(false);
          }}
          values={(v) => {
            handleChoosedUnit(v);
          }}
        />
      )}
    </div>
  );
};

export default RawMaterialManage;
